import Route from '@ember/routing/route';
import { inject as service } from '@ember/service';
import { COMPANY_PROFILE__COMPANY_INCLUDES, COMPANY_PROFILE__COMPANY_INCLUDES_ADMIN } from 'sh-www/constants/routes/company-profile';
import { trackPageViewFromTransition } from 'sh-www/utils/datalayer';

class CompanyNetworkUserRoute extends Route {
  @service('commands.user-commands') userCommandService;
  @service('commands.company-commands') companyCommandService;
  @service session;

  async model({ profileId }) {
    const { companyId } = this.paramsFor('company-profile');

    const companyIncludes = this.session.currentUser.isAdmin
    ? COMPANY_PROFILE__COMPANY_INCLUDES_ADMIN
    : COMPANY_PROFILE__COMPANY_INCLUDES;

    const company = await this.companyCommandService.loadCompany(companyId, companyIncludes);

    const user = await this.userCommandService.getUser(profileId, [
      `service-company-user-scores:company_id(${company.id})`,
      'service-company-user-scores.service',
      `company-seller-connections:in_network_or_extended(${company.id}).company`,
      'last-location',
      'location',
      'profile.languages',
      'profile.equipment',
      'services:sort(most-proof)',
    ]);

    return { user, company };
  }

  activate(transition) {
    super.activate(...arguments);
    trackPageViewFromTransition(this, transition, '/company/:id/user/:id/');
  }
}

export default CompanyNetworkUserRoute;
